import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Card, CardMedia, Grid, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import {
  default as CustomSelect,
  default as Select,
} from "../../../components/Select/Select";
import {
  getAppointmentHistoriesByPetId,
  getAppointmentsByVetIdAndDate,
  getAvailabilityByVetIdAndType,
  getClinicFacilities,
  getClinicHolidays,
  getServices,
} from "../../../redux/reducers/clinicSlice";
import { getVetHolidaysById } from "../../../redux/reducers/doctorSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import {
  getClinicPets,
  petAppointment,
} from "../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import {
  appointmentLaterList,
  appointmentList,
  oldIssueList,
  serviceTypes,
  serviceTypeWOSurgery,
  typeAppointemnt,
  typeList,
  typeListNew,
} from "../../../util/dropList";
import {
  adjustTime,
  getAllDatesFromArray,
  getAllSelectedSlots,
  getAvailableBayAtTime,
  getOnlyAvailableSlots,
  getPetSearchType,
  getRequiredSlotList,
  getSlotsForGroomer,
  getUnAvailableGroomList,
  getUpcoming60Dates,
} from "../../../util/function";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};

const initValues = {
  bookingType: "Walk-in",
  consultationMode: "Physical",
  serviceType: { name: "Consultation", value: "Consultation" },
  reason: [],
  vetName: null,
  appointmentOption: "Immediate",
  date: new Date(),
  referenceCase: null,
  serviceName: [],
  remarks: "",
  facility: null,
  petSearch: "",
};
const initErrors = {};
const initTimeObj = { times: [], ids: [] };

const VetBookAnAppointment = ({
  modalVisible,
  setBookModVisible,
  selectedVet,
}) => {
  const dispatch = useDispatch();
  const [modOpen, setModOpen] = useState(false);
  const [petValues, setPetValues] = useState(initValues);
  const [petErrors, setPetErrors] = useState(initErrors);
  const [selectTime, setSelectTime] = useState(null);
  const [selectTimeIdError, setSelectTimeIdError] = useState(false);
  const [holidayDates, setHolidayDates] = useState([]);
  const [selectedPet, setSelectedPet] = useState(null);
  const [timeObject, setTimeObject] = useState(initTimeObj);
  const {
    userDetails,
    vetAvailability,
    vetBookedApnts,
    petApntHistories,
    services,
    facilities,
  } = useSelector((state) => state?.clinic);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const clinicHolidays = useSelector((state) => state?.clinic?.holidays);
  const pets = useSelector((state) => state.pet.clinicPets);
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = JSON.parse(user);

  useEffect(() => {
    dispatch(getClinicHolidays());
    dispatch(getServices());
    dispatch(getClinicVets("?type=all"));
  }, []);

  useEffect(() => {
    setModOpen(modalVisible);
  }, [modalVisible]);

  useEffect(() => {
    if (
      !selectedVet?.doctorId ||
      !petValues?.date ||
      !petValues?.appointmentOption ||
      !petValues?.consultationMode
    ) {
      return;
    }
    if (petValues?.appointmentOption === "Later") {
      dispatch(getVetHolidaysById(selectedVet?.doctorId));
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId: selectedVet?.doctorId,
          type:
            (role === "ROLE_CLINIC" ? profile?.id : userDetails?.id) ===
            selectedVet?.doctorId
              ? "Physical"
              : petValues?.consultationMode,
        })
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId: selectedVet?.doctorId,
          date: moment(new Date(petValues?.date)).format("YYYY-MM-DD"),
          clinicId: profile?.id,
        })
      );
    }
  }, [
    selectedVet?.doctorId,
    petValues?.date,
    petValues?.appointmentOption,
    petValues?.consultationMode,
  ]);

  useEffect(() => {
    getHolidayDateList();
  }, [holidays, clinicHolidays, vetAvailability]);

  const getClinicPetsData = (srchTxt = "") => {
    if (srchTxt?.length === 0) return;
    dispatch(
      getClinicPets(
        `?type=all${getPetSearchType(
          srchTxt
        )}&search=${srchTxt}&page=1&itemSize=30`
      )
    );
  };

  const getHolidayDateList = () => {
    if (
      (holidays?.length === 0 || !holidays) &&
      (clinicHolidays?.length === 0 || !clinicHolidays) &&
      vetAvailability?.every((li) => li?.status)
    ) {
      return setHolidayDates([]);
    }
    const vetDates = getAllDatesFromArray(holidays) ?? [];
    const cliHolidays =
      clinicHolidays?.map((hl) => {
        return hl?.date;
      }) ?? [];
    const unAvilableDates =
      vetAvailability?.length > 0 ? getUpcoming60Dates(vetAvailability) : [];
    const mergedArray = vetDates?.concat(cliHolidays, unAvilableDates);
    setHolidayDates(uniq(mergedArray));
  };

  const handleReset = () => {
    setPetValues(initValues);
    setPetErrors(initErrors);
    setSelectTime(null);
    setSelectTimeIdError(false);
  };

  const onCloseMod = () => {
    handleReset();
    setModOpen(false);
    setBookModVisible(false);
    setSelectTime(null);
  };

  const onChange = (value, name) => {
    const reqObj = { ...petValues, [name]: value };
    const errObj = { ...petErrors };
    if (name === "petSearch") {
      getClinicPetsData(value);
    }
    if (name === "serviceType") {
      reqObj.serviceName = [];
      if (value?.value === "Surgery" || value?.value === "Grooming") {
        dispatch(getClinicFacilities());
      }
    }
    if (name === "serviceName") {
      errObj.serviceName = value?.length === 0;
    }
    setPetErrors(errObj);
    setPetValues(reqObj);
  };

  const handleSelectectedTimeIds = (time) => {
    const reqTimeIds = [...timeObject?.times, time];
    let ids = [];
    const reqList = {
      times: reqTimeIds?.length > 2 ? [time] : reqTimeIds,
    };
    if (reqList?.times?.length === 2) {
      ids = getAllSelectedSlots(
        getRequiredSlotList({
          availability: vetAvailability,
          date: petValues?.date,
          bookedApnts: vetBookedApnts,
        }),
        reqTimeIds
      );
      reqList.ids = ids;
    } else {
      ids.push(time);
      reqList.ids = ids;
    }
    setTimeObject(reqList);
    setSelectTimeIdError(reqTimeIds?.length === 2 ? false : true);
  };

  const handleSelectTime = (time) => {
    setSelectTime(time?.startTime);
    setSelectTimeIdError(false);
  };

  const getHistoryList = () => {
    if (!petApntHistories || petApntHistories?.length === 0) return [];
    return petApntHistories?.map((hl) => ({
      name: `Case Id: ${hl?.caseId ?? ""} ${hl?.serviceType}${
        hl?.serviceType === "Consultation"
          ? ` | ${
              Array.isArray(hl?.reason) ? hl?.reason?.join(", ") : hl?.reason
            }`
          : ""
      }`,
      value: hl?.appointmentId,
    }));
  };

  const getServiceList = (itm) => {
    const reqCat =
      itm === "Grooming"
        ? "Hygiene & Grooming"
        : itm === "Lab Tests"
        ? "Lab"
        : "Radiology";
    const reqList = [];
    let filList = services?.data?.filter((sl) => sl?.category === reqCat);
    if (itm === "Grooming") {
      if (facilities?.filter((fl) => fl?.type === "BathBays").length === 0) {
        filList = filList?.filter(
          (sl) =>
            sl?.subCategory !== "Bathing" &&
            sl?.subCategory !== "Spa/Pampering Services"
        );
      }
    }

    filList?.forEach((li) => {
      if (li?.serviceVariants?.length > 0) {
        li?.serviceVariants?.forEach((vrnt) => {
          const reqObj = {
            serviceId: li?.serviceId,
            serviceName: li?.serviceName,
            variantName: vrnt?.variantName ?? "",
            estimatedDuration: vrnt?.estimatedDuration ?? "",
            servicePrice: vrnt?.servicePrice ?? 0,
            variantId: vrnt?.variantId ?? null,
            value: vrnt?.variantName ?? "",
            name: vrnt?.variantName ?? "",
            category: li?.category,
            subCategory: li?.subCategory,
          };
          reqList.push(reqObj);
        });
      } else {
        const reqObj = {
          serviceId: li?.serviceId,
          serviceName: li?.serviceName,
          servicePrice: li?.servicePrice ?? 0,
          estimatedDuration: li?.estimatedDuration ?? "",
          name: li?.serviceName,
          value: li?.serviceName,
        };
        reqList.push(reqObj);
      }
    });
    return reqList ?? [];
  };

  const getFacilitiesByType = (type) => {
    const reqType = type === "Surgery" ? "OperationTheatre" : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => fl?.type === reqType)
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];

    return reqVetList;
  };

  const getFacilityUnAvailListById = (id) => {
    const reqFacility = facilities?.find((fl) => fl?.facilityId === id) ?? {};
    if (!reqFacility) return [];
    return (
      reqFacility?.clinicFacilitiesUnavaility
        ?.filter(
          (ua) =>
            ua?.appointmentDate === moment(petValues?.date).format("YYYY-MM-DD")
        )
        ?.map((li) => ({
          ...li,
          startTime: li?.appointmentStartTime,
          endTime: li?.appointmentEndTime,
        })) ?? []
    );
  };

  const handleSubmit = () => {
    if (
      petValues?.serviceType?.value === "Grooming" ||
      petValues?.serviceType?.value === "Lab Tests" ||
      petValues?.serviceType?.value === "Radiology Tests" ||
      petValues?.serviceType?.value === "Others" ||
      !selectedPet
    ) {
      const errObj = {
        serviceName: petValues?.serviceName?.length === 0,
        petSearch: !selectedPet,
      };
      return setPetErrors({ ...petErrors, ...errObj });
    }
    dispatch(showLoader());
    const data = {
      bookingType: petValues?.bookingType,
      consultationMode: petValues?.consultationMode,
      serviceType: petValues?.serviceType?.value,
      remarks: petValues?.remarks,
      immediate: petValues?.appointmentOption === "Immediate",
      appointmentDate:
        petValues?.appointmentOption === "Immediate"
          ? moment(new Date()).format("YYYY-MM-DD")
          : moment(new Date(petValues?.date)).format("YYYY-MM-DD"),
      doctorId: selectedVet?.doctorId,
    };
    if (petValues?.appointmentOption !== "Immediate") {
      if (petValues?.serviceType?.value === "Surgery") {
        data.appointmentStartTime = timeObject?.ids?.[0]?.startTime;
        data.appointmentEndTime =
          timeObject?.ids?.[timeObject?.ids?.length - 1]?.endTime;
        data.facility = petValues?.facility?.name;
        data.facilityId = petValues?.facility?.value;
      } else {
        data.appointmentStartTime = selectTime;
        data.appointmentEndTime = adjustTime(
          selectTime,
          getRequiredSlotList({
            availability: vetAvailability,
            date: petValues?.date,
            isDuration: true,
          })
        );
      }
    }
    if (
      petValues?.serviceType?.value === "Grooming" &&
      petValues?.appointmentOption !== "Immediate"
    ) {
      if (petValues?.serviceName?.length === 0) return;
      if (
        petValues?.serviceName?.some(
          (item) =>
            item?.subCategory?.includes("Bathing") ||
            item?.subCategory?.includes("Spa/Pampering Services")
        )
      ) {
        const reqTimeInMins = petValues?.serviceName?.reduce((acc, obj) => {
          return acc + (Number(obj?.estimatedDuration ?? 0) ?? 0);
        }, 0);
        data.appointmentStartTime = selectTime;
        data.appointmentEndTime = adjustTime(selectTime, reqTimeInMins);
        if (facilities?.filter((fl) => fl?.type === "BathBays")?.length === 1) {
          data.facility = getFacilitiesByType("Grooming")?.[0]?.name;
          data.facilityId = getFacilitiesByType("Grooming")?.[0]?.value;
        } else {
          const reqFacility = getAvailableBayAtTime(
            facilities?.filter((fl) => fl?.type === "BathBays"),
            selectTime
          );
          if (reqFacility) {
            data.facility = reqFacility?.name;
            data.facilityId = reqFacility?.facilityId;
          }
        }
      }
      // else {
      //   data.appointmentStartTime = selectTime;
      //   data.appointmentEndTime = adjustTime(
      //     selectTime,
      //     getRequiredSlotList({
      //       availability: vetAvailability,
      //       date: petValues?.date,i
      //       isDuration: true,
      //     })
      //   );
      // }
    }
    if (
      petValues?.serviceType?.value === "Radiology Tests" &&
      petValues?.appointmentOption !== "Immediate"
    ) {
      if (petValues?.serviceName?.length === 0) return;
      if (
        petValues?.serviceName?.some(
          (item) =>
            item?.subCategory?.includes("Imaging") ||
            item?.subCategory?.includes("Endoscopy")
        )
      ) {
        const reqTimeInMins = petValues?.serviceName?.reduce((acc, obj) => {
          return acc + (Number(obj?.estimatedDuration ?? 0) ?? 0);
        }, 0);
        data.appointmentStartTime = selectTime;
        data.appointmentEndTime = adjustTime(selectTime, reqTimeInMins);
      }
    }
    if (petValues?.serviceType?.value === "Consultation") {
      data.reason = petValues?.reason;
    }
    dispatch(petAppointment({ data, petId: selectedPet?.petId })).then(
      (res) => {
        if (res?.payload) {
          setBookModVisible(false);
          onCloseMod();
          dispatch(hideLoader());
        }
      }
    );
    dispatch(hideLoader());
  };

  return (
    <CustomModal
      open={modOpen}
      onClose={onCloseMod}
      header="Book an Appointment"
      modalWidth={80}
      modal
    >
      <Grid container spacing={2} className="ph20 scroll-80vh">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container className="flex-center">
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Card sx={cardSty} className="CustomCard-back-appointment">
                <div className="maint">
                  <div className="flex-row">
                    <Grid item xs={3}>
                      <div className="flex-center">
                        {selectedVet?.image ? (
                          <CardMedia
                            image={selectedVet?.image}
                            className="CustomCard-img3-bill"
                          />
                        ) : (
                          <div className="flex-center h50img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {selectedVet?.name?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={9}>
                      <div className="flex-row">
                        <div className="flex-start">
                          <div className="flex-column">
                            <div className="flex-row">
                              <Typography
                                variant="body1"
                                className="mb5 font-bold fs14 capitalize"
                              >
                                {selectedVet?.doctorId === profile?.id
                                  ? ""
                                  : "Dr."}
                                {selectedVet?.name}
                              </Typography>
                            </div>
                            <Typography
                              variant="body2"
                              className="mb10 txt-regular card-gray-color fs12"
                            >
                              {selectedVet?.speciality}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </div>
                </div>
              </Card>
            </Grid>
          </Grid>
          <Grid container className="flex-center">
            {!selectedPet && (
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="mb20">
                <CustomTextField
                  fullWidth
                  search
                  placeholder="Pet Search"
                  backgroundColor={AppColors.lightPink}
                  value={petValues?.petSearch}
                  handleChange={(e) => onChange(e?.target?.value, "petSearch")}
                />
                {petErrors?.petSearch && (
                  <Typography color="error" className="ml5 mt5 fs14">
                    Pet is Requried
                  </Typography>
                )}
              </Grid>
            )}
          </Grid>
          <Grid container className="flex-center">
            {petValues?.petSearch?.length > 0 && (
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                {pets?.pets?.length > 0 &&
                  pets?.pets?.map((petDet) => {
                    const pet = petDet?.listOfDatas;
                    return (
                      <Grid
                        container
                        spacing={1}
                        key={pet?.petId}
                        className="cursor"
                        onClick={() => {
                          setSelectedPet(pet);
                          setPetValues({ ...petValues, petSearch: "" });
                          setPetErrors({ ...petErrors, petSearch: false });
                          dispatch(getAppointmentHistoriesByPetId(pet?.petId));
                        }}
                      >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Card
                                sx={{
                                  borderRadius: 1,
                                  padding: 2,
                                  borderTopColor: AppColors.appPrimary,
                                }}
                                className="CustomCard-back-appointment"
                              >
                                <div className="maint">
                                  <div className="flex-row">
                                    <Grid item xs={3}>
                                      <div className="flex-center">
                                        {pet?.petImage ? (
                                          <CardMedia
                                            image={pet?.petImage}
                                            className="CustomCard-img3-bill"
                                          />
                                        ) : (
                                          <div className="flex-center h50img">
                                            <Typography className="font-bold fs30 white-color capitalize">
                                              {pet?.petName?.[0]}
                                            </Typography>
                                          </div>
                                        )}
                                      </div>
                                    </Grid>
                                    <Grid item xs={9}>
                                      <div className="flex-row">
                                        <div className="flex-start">
                                          <div className="flex-column">
                                            <div className="flex-row">
                                              <Typography
                                                variant="body1"
                                                className="mb10 font-bold fs14 capitalize"
                                              >
                                                {pet?.petName}
                                              </Typography>
                                              <Typography
                                                variant="body1"
                                                className={`ml5 font-medium capitalize fs14 ${
                                                  pet.gender === "male"
                                                    ? "card-blue-color"
                                                    : "card-rose-color"
                                                }`}
                                              >
                                                ({pet.gender})
                                              </Typography>
                                            </div>
                                            <Typography
                                              variant="body2"
                                              className="mb10 txt-regular card-gray-color fs12"
                                            >
                                              {pet.breed}
                                            </Typography>
                                          </div>
                                        </div>
                                      </div>
                                    </Grid>
                                  </div>
                                  <div>
                                    <div className="flex-row parentcontainer">
                                      <div className="flex-row iconcontainer">
                                        <AccountCircleOutlinedIcon
                                          sx={{ width: 25, height: 25 }}
                                        />
                                        <Typography className="font-bold fs14 capitalize flex-center h35">
                                          {pet.userName}
                                        </Typography>
                                      </div>
                                      <div className="meeting-doctor">
                                        {moment(pet?.dob).fromNow()} ({pet?.dob}
                                        )
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>
            )}
          </Grid>

          <Grid container className="flex-center">
            {selectedPet && (
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Card
                      sx={{
                        borderRadius: 1,
                        padding: 2,
                        borderTopColor: AppColors.appPrimary,
                      }}
                      className="CustomCard-back-appointment"
                    >
                      <div className="maint">
                        <div className="flex-row">
                          <Grid item xs={3}>
                            <div className="flex-center">
                              {selectedPet?.petImage ? (
                                <CardMedia
                                  image={selectedPet.petImage}
                                  className="CustomCard-img3-bill"
                                />
                              ) : (
                                <div className="flex-center h50img">
                                  <Typography className="font-bold fs30 white-color capitalize">
                                    {selectedPet?.petName?.[0]}
                                  </Typography>
                                </div>
                              )}
                            </div>
                          </Grid>
                          <div className="flex-row">
                            <div className="flex-start">
                              <div className="flex-column">
                                <div className="flex-row">
                                  <Typography
                                    variant="body1"
                                    className="mb10 font-bold fs14 capitalize"
                                  >
                                    {selectedPet.petName}
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    className={`ml5 font-medium capitalize fs14 ${
                                      selectedPet.gender === "male"
                                        ? "card-blue-color"
                                        : "card-rose-color"
                                    }`}
                                  >
                                    ({selectedPet.gender})
                                  </Typography>
                                </div>
                                <Typography
                                  variant="body2"
                                  className="mb10 txt-regular card-gray-color fs12"
                                >
                                  {selectedPet.breed}
                                </Typography>
                              </div>
                            </div>
                          </div>
                          <div></div>
                        </div>
                        <div>
                          <div className="flex-row parentcontainer">
                            <div className="flex-row iconcontainer">
                              <AccountCircleOutlinedIcon
                                sx={{ width: 25, height: 25 }}
                              />
                              <Typography className="font-bold fs14 capitalize flex-center h35">
                                {selectedPet.userName}
                              </Typography>
                            </div>
                            <div className="meeting-doctor">
                              {moment(selectedPet?.dob).fromNow()} (
                              {selectedPet?.dob})
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
          <CustomSelect
            list={typeAppointemnt}
            value={petValues?.bookingType}
            handleChange={(e) => onChange(e?.target?.value, "bookingType")}
            name="bookingType"
            label="Booking Type * "
            select
            helperText={petErrors?.bookingType}
            error={!!petErrors?.bookingType}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
          <CustomSelect
            list={petValues.bookingType === "Walk-in" ? typeListNew : typeList}
            value={
              petValues?.bookingType === "Walk-in"
                ? "Physical"
                : petValues?.consultationMode
            }
            handleChange={(e) => onChange(e?.target?.value, "consultationMode")}
            name="consultationMode"
            label="Consultation Mode * "
            select
            helperText={petErrors?.consultationMode}
            error={!!petErrors?.consultationMode}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <CustomSelect
            list={
              petValues?.consultationMode === "Physical"
                ? serviceTypes
                : serviceTypeWOSurgery
            }
            value={petValues?.serviceType}
            handleChange={(e, value) => onChange(value, "serviceType")}
            search
            helperText={petErrors?.serviceType}
            error={!!petErrors?.serviceType}
            label="Service Type *"
            name="serviceType"
          />
        </Grid>
        {petValues?.serviceType?.value === "Consultation" ? (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomSelect
              list={oldIssueList}
              value={petValues?.reason}
              handleChange={(e) => {
                onChange(e, "reason");
              }}
              reason
              label="Reason"
              name="reason"
              helperText={petErrors?.reason}
              error={!!petErrors?.reason}
            />
          </Grid>
        ) : null}
        {petValues?.serviceType?.value === "Grooming" ||
        petValues?.serviceType?.value === "Lab Tests" ||
        petValues?.serviceType?.value === "Radiology Tests" ||
        petValues?.serviceType?.value === "Others" ? (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomSelect
              list={getServiceList(petValues?.serviceType?.value)}
              value={petValues?.serviceName}
              handleChange={(e) => onChange(e, "serviceName")}
              service
              label="Service Name *"
              name="serviceName"
              helperText={petErrors?.serviceName}
              error={!!petErrors?.serviceName}
            />
          </Grid>
        ) : null}
        {petValues?.reason?.includes("FollowUp") &&
        petValues?.serviceType?.value === "Consultation" ? (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomSelect
              list={getHistoryList()}
              value={petValues?.referenceCase}
              handleChange={(e, value) => onChange(value, "referenceCase")}
              search
              label="Reference Case"
              name="referenceCase"
              helperText={petErrors?.referenceCase}
              error={!!petErrors?.referenceCase}
            />
          </Grid>
        ) : null}

        {petValues?.serviceType?.value === "Surgery" ? (
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <Select
              list={getFacilitiesByType(petValues?.serviceType?.value)}
              value={petValues?.facility}
              handleChange={(e, value) => onChange(value, "facility")}
              name="facility"
              search
              helperText={petErrors?.facility}
              error={!!petErrors?.facility}
              label="Facility"
              labelTop
            />
          </Grid>
        ) : null}
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <div className="flex-row-ali-cen mtMin5">
            <div className="txt-mont fs14 mtMin5">
              Appointment <span className="red-color">*</span> :
            </div>
            <div className="ml5">
              <CustomCheckbox
                radio
                value={petValues?.appointmentOption}
                onChange={(e) =>
                  onChange(e?.target?.value, "appointmentOption")
                }
                radios={
                  petValues.typeOfAppointment === "Phone"
                    ? appointmentLaterList
                    : appointmentList
                }
                defaultValue={petValues?.appointmentOption}
              />
            </div>
          </div>
          {petErrors?.appointmentOption && (
            <Typography color="error" className="ml5 mt5 fs14">
              Appointment is Required
            </Typography>
          )}
        </Grid>
        {/* {petValues?.serviceType?.value === "Surgery" &&
        petValues?.appointmentOption === "Immediate" ? (
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <CustomTextField
              name="kennelNumber"
              fullWidth
              handleChange={(e) => onChange(e?.target?.value, "kennelNumber")}
              value={petValues?.kennelNumber}
              helperText={petErrors?.kennelNumber}
              error={!!petErrors?.kennelNumber}
              label="Kennel Number "
            />
          </Grid>
        ) : null} */}
        {petValues?.appointmentOption === "Later" && (
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <div className="mb20">
              <CustomTextField
                name="date"
                value={petValues?.date}
                labelTop
                fullWidth
                handleChange={(e) => onChange(e?.target?.value, "date")}
                mobileDateWithBatch
                markDateList={holidayDates ?? []}
                minDate={new Date()}
              />
            </div>
          </Grid>
        )}
        {petValues?.appointmentOption === "Later" &&
          petValues?.date &&
          selectedVet?.doctorId && (
            <div className="w100Per">
              <div className="flex-row-wrap1 mh10">
                {(petValues?.serviceType?.value === "Surgery" &&
                petValues?.facility?.value
                  ? getOnlyAvailableSlots(
                      getFacilityUnAvailListById(petValues?.facility?.value),
                      getRequiredSlotList({
                        availability: vetAvailability,
                        date: petValues?.date,
                        bookedApnts: vetBookedApnts,
                        holidays,
                      })
                    )
                  : petValues?.serviceType?.value === "Grooming"
                  ? facilities?.filter((fl) => fl?.type === "BathBays")
                      ?.length === 1
                    ? getUnAvailableGroomList(
                        facilities?.filter((fl) => fl?.type === "BathBays"),
                        getRequiredSlotList({
                          availability: vetAvailability,
                          date: petValues?.date,
                          bookedApnts: vetBookedApnts,
                          holidays,
                        })
                      )
                    : getSlotsForGroomer(
                        facilities?.filter((fl) => fl?.type === "BathBays"),
                        getRequiredSlotList({
                          availability: vetAvailability,
                          date: petValues?.date,
                          bookedApnts: vetBookedApnts,
                          holidays,
                        })
                      )
                  : getRequiredSlotList({
                      availability: vetAvailability,
                      date: petValues?.date,
                      bookedApnts: vetBookedApnts,
                      holidays,
                    })
                )?.length > 0 &&
                  (petValues?.serviceType?.value === "Surgery" &&
                  petValues?.facility?.value
                    ? getOnlyAvailableSlots(
                        getFacilityUnAvailListById(petValues?.facility?.value),
                        getRequiredSlotList({
                          availability: vetAvailability,
                          date: petValues?.date,
                          bookedApnts: vetBookedApnts,
                          holidays,
                        })
                      )
                    : petValues?.serviceType?.value === "Grooming"
                    ? facilities?.filter((fl) => fl?.type === "BathBays")
                        ?.length === 1
                      ? getUnAvailableGroomList(
                          facilities?.filter((fl) => fl?.type === "BathBays"),
                          getRequiredSlotList({
                            availability: vetAvailability,
                            date: petValues?.date,
                            bookedApnts: vetBookedApnts,
                            holidays,
                          })
                        )
                      : getSlotsForGroomer(
                          facilities?.filter((fl) => fl?.type === "BathBays"),
                          getRequiredSlotList({
                            availability: vetAvailability,
                            date: petValues?.date,
                            bookedApnts: vetBookedApnts,
                            holidays,
                          })
                        )
                    : getRequiredSlotList({
                        availability: vetAvailability,
                        date: petValues?.date,
                        bookedApnts: vetBookedApnts,
                        holidays,
                      })
                  )?.map((item, i) => {
                    return (
                      <div
                        key={i}
                        onClick={() => {
                          petValues?.serviceType?.value === "Surgery"
                            ? handleSelectectedTimeIds(item)
                            : handleSelectTime(item);
                        }}
                        className={
                          (
                            petValues?.serviceType?.value === "Surgery"
                              ? timeObject?.ids?.find(
                                  (id) => id?.startTime === item?.startTime
                                )
                              : selectTime === item?.startTime
                          )
                            ? "bgContainerSelected cursor"
                            : "bgContainerUnselected cursor"
                        }
                      >
                        {item?.startTime}
                      </div>
                    );
                  })}
              </div>
            </div>
          )}

        {selectTimeIdError && (
          <Typography color="error" className="ml5 mt5 fs14">
            Time is Requried
          </Typography>
        )}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <CustomTextField
            name="remarks"
            fullWidth
            handleChange={(e) => onChange(e?.target?.value, "remarks")}
            value={petValues?.remarks}
            label="Remarks"
            multiline
          />
        </Grid>
        <div className="flex1-center mt20">
          <div>
            <CustomButton text="Submit" onClick={handleSubmit} smallBtn />
          </div>
        </div>
      </Grid>
    </CustomModal>
  );
};

export default VetBookAnAppointment;
